import _ from 'lodash';
import {
    FETCH_MTOKNA_CODES,
    CLEAN_MTOKNA_CODES,
    CHANGE_MTOKNA_CODE,
    DELETE_MTOKNA_CODE,
} from './types';
import {request, __} from '../functions';

export const fetchMtoknaCodes = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/codes', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_CODES, payload: data });
    });
};

export const cleanMtoknaCodes = () => ({ type: CLEAN_MTOKNA_CODES });

export const changeMtoknaCode = (screen, id, code, sku) => {
    return dispatch => request(`/mtokna/editCode/${id}`, { code, sku }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť kód'));
            return;
        }

        screen.showSnackbar('success', __('Kód bol zmenený'));

        dispatch({ type: CHANGE_MTOKNA_CODE, payload: { id, code, sku } });
    });
};

export const deleteMtoknaCode = (screen, id) => {
    return dispatch => request(`/mtokna/removeCode/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Kód sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Kód bol zmazaný'));

        dispatch({ type: DELETE_MTOKNA_CODE });
    });
};
